import { render, staticRenderFns } from "./popover.vue?vue&type=template&id=27b2989c&scoped=true&"
import script from "./popover.vue?vue&type=script&setup=true&lang=ts&"
export * from "./popover.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./popover.vue?vue&type=style&index=0&id=27b2989c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b2989c",
  null
  
)

export default component.exports